import React, { Component } from 'react';
// import { connect } from 'react-redux'
class Dropdown extends Component { // eslint-disable-line react/prefer-stateless-function
    constructor(props) {
        super(props);
        this.state = {

        }
    }


    render() {
        const { input, data, dis, meta: { touched, error } } = this.props;
        let selectValue;
        if (this.props.type === 'PORTFOLIO_BUY') {
            selectValue = this.props.selectedValue
        } else {
            selectValue = this.props.input.value
        }
        let selectedZone;
        if (this.props.input.name === 'zone') {
            if (this.props.selectedZone) {
                if (this.props.selectedZone.length <= 0) {
                    selectedZone = ''
                } else if (this.props.selectedZone.length === 1) {
                    selectedZone = this.props.selectedZone[0].name
                    selectValue = this.props.selectedZone[0].id
                } else if (this.props.selectedZone.length > 1) {
                    selectedZone = ''
                }
            } else {
                selectValue = ''
            }
        }
        return (
            <div>
                {/* <label htmlFor={label}>{label}</label> */}
                < select {...input} className="form-control" readOnly disabled={dis} value={selectValue} >
                    {/* {this.productSelect} */}
                    
                    {
                        data.map(p => {
                            return (p.name) ?
                                < option key={p.name} value={p.id} selected={selectedZone} >
                                    {p.name}
                                </option>
                                :(p.corporateName && !p.productName)?
                                <option key={p.corporateName} value={p.id}>
                                        {p.corporateName}
                                    </option>
                                : (p.id) ?
                                    <option key={p.productName} value={p.id}>
                                        {p.productName}
                                    </option>
                                    : (p.id === undefined) ?
                                        <option selected={this.props.selectedValue} key={p} value={p}>
                                            {p}
                                        </option>
                                        : <option value="">Select</option>

                        })
                    }
                </select >
                {touched && error && <span>{error}</span>}
            </div >
        );
    }
}

export default Dropdown;